<div class="skl-job-logs" aria-busy="true" aria-label="Loading job logs">
  <div class="skl-header">
    <div>
      <app-skeleton width="260px" height="22px" borderRadius="4px" marginBottom="10px"></app-skeleton>
      <app-skeleton width="280px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
    </div>
    <app-skeleton width="150px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
  </div>

  <div class="skl-card">
    <div class="skl-card__header">
      <app-skeleton width="120px" height="16px" borderRadius="4px" marginBottom="0"></app-skeleton>
    </div>
    <div class="skl-card__body skl-summary-grid">
      @for (stat of summaryStats; track stat) {
        <div>
          <app-skeleton width="72%" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="54%" height="16px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
      }
    </div>
  </div>

  <app-job-logs-table-skeleton></app-job-logs-table-skeleton>
</div>